/**
 * Класс обертка отвечает за переключения видимости элемента, за счет добавление/удаление css класса {@link hideClassName}
 * сдержащего display: none!important
 */
import ClassSwitcherElement from './ClassSwitcherElement'

export default class VisibilitySwitcherElement extends ClassSwitcherElement {
   /**
    * @param element       - элемент видимость которого нужно переключать
    * @param hideClassName - имя класса содержащего свойство "display: none!important"
    */
   constructor(element, hideClassName = 'hide') {
      super(element, hideClassName)
   }

   hide = () => this.addClass()

   show = () => this.removeClass()
}